module.exports = __webpack_public_path__ + "img/tabi2.05cf53fa.png";